import { cn } from '@ridemaadi/utils';
import { Logo } from './Logo';

/** Branded loading state using the official page-load logo (600–900ms fade). */
export function BrandedLoadingState({
  label = 'Loading…',
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 py-16 rm-fade-in',
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Logo variant="pageload" className="animate-pulse motion-reduce:animate-none" />
      <p className="text-sm text-muted">{label}</p>
    </div>
  );
}
